import { render, staticRenderFns } from "./training-m.vue?vue&type=template&id=3f4dacce&"
import script from "./training-m.vue?vue&type=script&lang=js&"
export * from "./training-m.vue?vue&type=script&lang=js&"
import style0 from "./training-m.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports